import { get as _get } from 'lodash';


export const defaultColumns: any = [
  {
    title: 'select-all-btn',
    active: false,
    col: 'select-btn',
    cssWidth: '130px',
  },
  {
    title: '',
    sortable: false,
    sort: 'desc',
    active: false,
    col: 'photo',
    columnName: 'photo',
    type: 'image',
    link: true,
    cssWidth: '93px',
  },
  {
    title: 'Part no.',
    sortable: true,
    truncate: true,
    sort: 'desc',
    active: false,
    col: 'partNumber',
    columnName: 'partNumber',
    link: true,
    data: (row: any) => {
      return _get(row, 'partNumber');
    },
    cssWidth: '10%',
  },
  {
    title: 'Part type',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'partTerminology',
    columnName: 'partTerminology',
    truncate: true,
    data: (row: any) => {
      return _get(row, 'details.partTerminology.name', _get(row, 'partTerminology.name', ''));
    },
    cssWidth: '15%',
  },
  {
    title: 'Description',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'description_des_en',
    columnName: 'description_des_en',
    truncate: true,
    data: (row: any) => {
      return _get(row, 'descriptions.DES.EN');
    }
  },
  {
    title: 'Fitments',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'fitments',
    columnName: 'fitments',
    link: true,
    linkEmptyUnderlineOnHover: true,
    permissions: ['admin', 'fitments'],
    cssWidth: '90px',
  },
  {
    title: 'Jobber price 1',
    columnName: 'price_jobber_1_usd',
    col: 'price_jobber_1_usd',
    sortable: true,
    sort: 'desc',
    active: false,
    type: 'currency',
    cssWidth: '110px',
    data: (row: any) => {
      return _get(row, 'price_jobber_1.USD');
    }
  },
  {
    title: 'Retail price 1',
    col: 'price_retail_1_usd',
    columnName: 'price_retail_1_usd',
    sortable: true,
    sort: 'desc',
    active: false,
    cssWidth: '110px',
    type: 'currency',
    data: (row: any) => {
      return _get(row, 'price_retailer_1.USD');
    }
  },
  {
    title: 'Modified',
    col: 'updated_at',
    columnName: 'updated_at',
    sortable: true,
    sort: 'desc',
    active: false,
    cssWidth: '110px',
    type: 'date',
  },
  {
    title: 'Score',
    col: 'score',
    columnName: 'score',
    sortable: true,
    sort: 'desc',
    active: false,
    cssWidth: '50px',
    type: 'score',
  },
];
